import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext.tsx';

import { useFormik } from 'formik'
import * as yup from 'yup'; 

interface NewsModalProps {
    isOpen: boolean;
    onClose: () => void;
}


const NewsModalPdf: React.FC<NewsModalProps> = ({
    isOpen,
    onClose,
}) => { 



    const { translations } = useLanguage();



    const validationSchema = yup.object({
        email: yup.string()
            .email('email invalide')  // Ensure it's a valid email format
            .required('email is required'),
        firstName: yup.string().required('first Name is required'),
        lastName: yup.string().required('last Name is required'),
        company: yup.string()
    })


    const formikData = useFormik({
        initialValues: {
            email: '',
            firstName: '',
            lastName: '',
            company: ''
        },
        validationSchema,
        onSubmit: async (values) => {

            if (values.email && values.firstName && values.lastName) {
                localStorage.clear()
                const email = values.email;
                const firstName = values.firstName;
                const lastName = values.lastName;
                const company = values.company;
                try {
                    const response = await fetch('/api/server', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            firstName: firstName,
                            lastName: lastName,
                            company: company,
                            email: email, 

                        }),
                    });
                    // console.log('response', await response.json())

                    if (!response.ok) {
                        throw new Error('Failed to send message');
                    }
                    const result = await response.json();
                    console.log('Success:', result);
                    return result;
                } catch (error) {
                    console.error('Error:ddd', error);
                    throw error;
                }
            }
        }
    })


    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                <div className="p-6 pt-0">
                    <div className="flex justify-between items-start sticky-btn ">
                        <h3 className="text-2xl font-light"></h3>
                        <button
                            onClick={onClose}
                            className="bg-gray-400/50 hover:bg-gray-500/50 transition-colors rounded-full p-2"
                        >
                            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div className="prose max-w-none">
                        <div className='container mx-auto p-5'>
                            <form onSubmit={formikData.handleSubmit} >
                                <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                                    <div>
                                        <label className='text-md text-[#111827]'>{translations.FirstName}*</label>
                                        <input className={`border border-gray-300 rounded-md w-full p-2 
                                        ${formikData.touched.email && Boolean(formikData.errors.firstName) ? "border-red-500" : ""}`}
                                            onChange={formikData.handleChange}
                                            id="firstName"
                                            value={formikData.values.firstName}
                                            type="text"

                                            placeholder={translations.FirstName} />
                                    </div>
                                    <div>
                                        <label className='text-md text-[#111827]'>{translations.LastName}*</label>
                                        <input className={`border border-gray-300 rounded-md w-full p-2 
                                        ${formikData.touched.email && Boolean(formikData.errors.lastName) ? "border-red-500" : ""}`}
                                            onChange={formikData.handleChange}
                                            id="lastName"
                                            value={formikData.values.lastName}
                                            type="text"
                                            placeholder={translations.LastName} />
                                    </div>
                                    <div>
                                        <label className='text-md text-[#111827]'>{translations.Company}</label>
                                        <input className={`border border-gray-300 rounded-md w-full p-2 
                                           ${formikData.touched.email && Boolean(formikData.errors.company) ? "border-red-500" : ""}`}
                                            onChange={formikData.handleChange}
                                            id="company"
                                            value={formikData.values.company}
                                            type="text"
                                            placeholder={translations.Company} />
                                    </div>
                                    <div>
                                        <label className='text-md text-[#111827]'>{translations.EmailAddress}*</label>
                                        <input className={`border border-gray-300 rounded-md w-full p-2 
                                        ${formikData.touched.email && Boolean(formikData.errors.email) ? "border-red-500" : ""}`}
                                            onChange={formikData.handleChange}
                                            id="email"
                                            value={formikData.values.email}
                                            type="email"
                                            placeholder={translations.EmailAddress} />
                                    </div>
                                </div>
                                <div className='block md:flex gap-3 justify-end'>
                                    <button
                                        onClick={() => { formikData.resetForm(), onClose() }}
                                        className='bg-gray-600  rounded-xl p-2 px-4 text-sm text-white my-3'>
                                        {translations.cancel}
                                    </button>
                                    <button type="submit"
                                        className='bg-[#d60530] rounded-xl p-2 px-4 text-sm text-white my-3'>
                                        {translations.send}
                                    </button>
                                </div>
                            </form>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsModalPdf;
